var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1667 26.3333L23.5001 23M23.5001 23L26.8334 26.3333M23.5001 23V30.5M30.1667 26.9524C31.1847 26.1117 31.8334 24.8399 31.8334 23.4167C31.8334 20.8854 29.7814 18.8333 27.2501 18.8333C27.068 18.8333 26.8976 18.7383 26.8052 18.5814C25.7185 16.7374 23.7121 15.5 21.4167 15.5C17.965 15.5 15.1667 18.2982 15.1667 21.75C15.1667 23.4718 15.863 25.0309 16.9892 26.1613",
    stroke: "#EF4444",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FECACA",
    strokeWidth: 6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.fdb61365a85a723f409dd599487e3f61.svg";
export { ForwardRef as ReactComponent };